import { AsyncAction } from '../../../../base-classes/asyncAction';
import { IPulseRequestConfiguration, PulseRequestConfiguration } from '../../../types/PulseInterfaces';
import { mapParamsToObject } from '../../../../utilities/mapParamsToObject';

import { SelectedStationObservationsProvider } from '../../../providers/WeatherStationObservations/SelectedStation/selectedStationObservationsProvider';

export const GET_STATION_OBSERVATIONS = new AsyncAction('GET_STATION_OBSERVATIONS');

/* TODO: refactor this and replace inputParameters with after updating usePulseAPI() hook.
export function getStationObservations(
    apiParameters: IGetStationObservationParams
    requestConfiguration: IPulseRequestConfiguration
*/

/**
 * getStationObservations will always fetch observations for a single weather station
 * @param apiParameters: IGetStationObservationsParams
 * -- All of the parameters for the Pulse Observations API to be aware of when requesting observations for a station
 * -- API Docs are available here -- http://currentstationobsapi-obs.weatherbug.net/swagger
 * @param requestConfiguration: IPulseRequestConfiguration
 * -- The necessary configuration for the store/provider and pulse to determine things like
 * -- 1. Is this a valid request?
 * -- 2. Was this recently fetched and cachable result can be returned or should this be refreshed?
 * -- 3. Etc ...
 */
export function getStationObservations(
    inputParameters: any
) {
    // TODO: Refactor the usePulse call in ReactNative and Web to split the API Endpoint specific parameters from common request properties
    const apiParameters: IGetStationObservationsParams = { ...inputParameters };
    const requestConfiguration = new PulseRequestConfiguration({
        ...inputParameters,
        verboseResponseKeys: inputParameters.verbose
    });
    
    return {
        type: GET_STATION_OBSERVATIONS.base,
        payload: getStationObservationsActionPayload({ apiParameters, requestConfiguration })
    };
}

async function getStationObservationsActionPayload({ apiParameters, requestConfiguration }: {
    apiParameters: IGetStationObservationsParams;
    requestConfiguration: IPulseRequestConfiguration;
}) {
    const {
        authId,
        baseUrl,
        forceRefreshOfCachedData: refresh,
        logger,
        options,
        secret
    } = requestConfiguration;
    
    const storeProvider = new SelectedStationObservationsProvider(baseUrl, authId, secret, options, logger);
    return await storeProvider.fetchCurrentStationObservations({ apiParameters, requestConfiguration });
}

/**
 * Input Parameters for making an API request to Pulse for a single station observation.
 */
export interface IGetStationObservationsParams {
    directionUnit?: number;
    disableRollover?: boolean;
    distanceUnit?: number;
    fml?: boolean;
    isCached?: boolean;
    latitude?: string;
    longitude?: string;
    precipitationRateUnit?: number;
    precipitationUnit?: number;
    pressureUnit?: number;
    providerId?: number;
    roundingProfile?: string;
    searchRadius?: number;
    speedUnit?: number;
    stationId?: string;
    stationState?: string;
    stationType?: string;
    temperatureUnit?: number;
    includePrecip?: boolean;
}
